import $ from 'jquery';

if ($('.news-card').length) {
	$(window).on('load', function () {
		var hash = window.location.hash;
		var hashCategory = hash.replace('#', '');

		var selectedCategory = 'all';
		var page = 1;
		const perPage = 12;

		//Check if the window has a hash on load and hide the cards that don't have the hash category
		if (hashCategory.length) {
			selectedCategory = hashCategory;
			filterNews()
		}
		checkFilterTab()


		function checkFilterTab() {
			var $selectedTab = $('.js-sort .filter-tab[value=' + selectedCategory + ']')
			$selectedTab.prop("checked", true).trigger('change')
		}

		function filterNews() {
			// Show and hide cards based on selected category
			$('.news-card').addClass('hide-card')

			if (selectedCategory == 'all') {
				$('.featured-news-card').removeClass('hide-card')
				var $allowedNewsCards = $('.news-card:not(.is-featured-article)')
			} else {
				$('.featured-news-card').addClass('hide-card')
				var $allowedNewsCards = $('.news-card.' + selectedCategory)
			}
			
			// show the ones that are allowed, up to the paginated number
			$allowedNewsCards.slice(0, page * perPage).removeClass('hide-card');

			// show or hide the load more button
			if ($allowedNewsCards.length > page * perPage) {
				$('.js-button.load-more').show();
			} else {
				$('.js-button.load-more').hide();
			}
		}

		//Sorts the main filtering categories
		$('.js-sort .filter-tab').on('change', function (e) {
			e.preventDefault();

			var $this = $(this);
			var category = $this.prop('value');
			
			window.location.hash = category;  //update the hash
			selectedCategory = category;
			
			page = 1;
			filterNews();

			// hide the mobile menu
			$('#news-filter-toggle').prop('checked', false)

		});

		$('.js-button.load-more').on('click', function (e) {
			e.preventDefault();
			page ++;
			filterNews();
		})
	});
}
